import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import Select from "react-select";
import { Link } from "react-router-dom";
import {
  FaUserGraduate,
  FaChalkboardTeacher,
  FaMoneyBillWave,
  FaBell,
  FaCalendarAlt,
  FaFileInvoice,
} from "react-icons/fa";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { ApiUrl } from "../../ApiUrl";

const AutoLayoutExample = () => {
  const [academicContext, setAcademicContext] = useState(() => ({
    academic_year_id: localStorage.getItem("academicSessionId") || "",
    org_id: localStorage.getItem("orgId") || "",
    branch_id: localStorage.getItem("branchId") || "",
  }));
  const [totalStudents, setTotalStudents] = useState(0);
  const [totalTeachers, setTotalTeachers] = useState(0);
  const [todayAttendance, setTodayAttendance] = useState({
    total_student: 0,
    present_student: 0,
    absent_student: 0,
    leave_student: 0,
    not_marked_student: 0,
  });
  const [sessionFeeDetails, setSessionFeeDetails] = useState({});
  const [feeTableData, setFeeTableData] = useState([]);
  const [monthlyCollection, setMonthlyCollection] = useState(0);
  const monthOptions = [
    { label: "January", value: 0 },
    { label: "February", value: 1 },
    { label: "March", value: 2 },
    { label: "April", value: 3 },
    { label: "May", value: 4 },
    { label: "June", value: 5 },
    { label: "July", value: 6 },
    { label: "August", value: 7 },
    { label: "September", value: 8 },
    { label: "October", value: 9 },
    { label: "November", value: 10 },
    { label: "December", value: 11 },
  ];
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [yearOptions, setYearOptions] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const readAcademicContext = () => ({
    academic_year_id: localStorage.getItem("academicSessionId") || "",
    org_id: localStorage.getItem("orgId") || "",
    branch_id: localStorage.getItem("branchId") || "",
  });

  const formatDateKey = (dateObj) => {
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatNotificationDate = (value) => {
    if (!value) return "";
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return String(value);
    return parsed.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const getAcademicYearsFromCode = (code) => {
    if (!code || typeof code !== "string") return [];

    const parts = code.split("-");
    if (parts.length !== 2) return [];

    const startYear = Number(parts[0]);
    let endYear = Number(parts[1]);

    if (Number.isNaN(startYear) || Number.isNaN(endYear)) return [];

    if (endYear < 100) {
      endYear = Math.floor(startYear / 100) * 100 + endYear;
    }

    if (endYear < startYear) {
      endYear = startYear;
    }

    const years = [];
    for (let y = startYear; y <= endYear; y++) {
      years.push(y);
    }
    return years;
  };

  const generateFeeCalendarData = () => {
    const start = new Date(selectedYear, selectedMonth, 1);
    const end = new Date(selectedYear, selectedMonth + 1, 0);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    const feeMap = {};
    feeTableData.forEach((item) => {
      const key = String(item.receipt_date || "").split("T")[0];
      const amount = Number(item.received_amount || 0);
      if (!key) return;
      feeMap[key] = (feeMap[key] || 0) + amount;
    });

    const calendarData = [];
    const week = [];
    const currentDate = new Date(start);
    const startDayOfWeek = currentDate.getDay();

    for (let i = 0; i < startDayOfWeek; i++) {
      week.push(null);
    }

    while (currentDate <= end) {
      const dateCopy = new Date(currentDate);
      const dateStr = formatDateKey(dateCopy);

      week.push({
        day: dateCopy.getDate(),
        date: dateStr,
        feeReceived: feeMap[dateStr] || null,
      });

      if (week.length === 7) {
        calendarData.push(week.slice());
        week.length = 0;
      }

      currentDate.setDate(currentDate.getDate() + 1);
    }

    if (week.length > 0) {
      while (week.length < 7) {
        week.push(null);
      }
      calendarData.push(week);
    }

    return calendarData;
  };

  useEffect(() => {
    const syncAcademicContext = () => {
      setAcademicContext(readAcademicContext());
    };

    window.addEventListener("academicSessionChanged", syncAcademicContext);
    window.addEventListener("storage", syncAcademicContext);

    return () => {
      window.removeEventListener("academicSessionChanged", syncAcademicContext);
      window.removeEventListener("storage", syncAcademicContext);
    };
  }, []);

  useEffect(() => {
    const { academic_year_id, org_id, branch_id } = academicContext;

    if (!academic_year_id || !org_id || !branch_id) return;

    const today = formatDateKey(new Date());

    fetch(
      `${ApiUrl.apiurl}AttendanceDashBoard/dashboard/?academic_year_id=${academic_year_id}&org_id=${org_id}&branch_id=${branch_id}&date=${today}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data?.message === "success" && data?.data) {
          setTodayAttendance(data.data);
          setTotalStudents(Number(data.data.total_student || 0));
        }
      })
      .catch((err) => console.error("Attendance dashboard error:", err));

    fetch(
      `${ApiUrl.apiurl}STAFF/registrationstaffList/?org_id=${org_id}&branch_id=${branch_id}`
    )
      .then((res) => res.json())
      .then((data) => {
        const staffList = Array.isArray(data?.data) ? data.data : [];
        const teacherCount = staffList.filter((item) => {
          const employeeType = String(item?.employee_type || "").toLowerCase();
          return (
            employeeType.includes("teacher") ||
            employeeType.includes("teach")
          );
        }).length;
        setTotalTeachers(teacherCount);
      })
      .catch((err) => console.error("Staff list error:", err));
  }, [academicContext]);

  useEffect(() => {
    const sessionId = localStorage.getItem("academicSessionId");
    if (!sessionId) {
      setYearOptions([]);
      return;
    }

    fetch(`${ApiUrl.apiurl}AcademicYear/GetAllAcademicYear/`)
      .then((res) => res.json())
      .then((data) => {
        const years = Array.isArray(data?.data) ? data.data : [];
        const selectedSession = years.find(
          (item) => String(item.id) === String(sessionId)
        );
        const sessionCode = selectedSession?.sesion_code || "";

        const sessionYears = getAcademicYearsFromCode(sessionCode);
        const options = sessionYears.map((year) => ({
          label: String(year),
          value: year,
        }));

        setYearOptions(options);

        if (options.length) {
          const currentYear = new Date().getFullYear();
          const matched = options.find((opt) => opt.value === currentYear);
          setSelectedYear((matched || options[0]).value);
        }
      })
      .catch((err) => {
        console.error("Error fetching academic years:", err);
        setYearOptions([]);
      });
  }, [academicContext.academic_year_id]);

  useEffect(() => {
    const { academic_year_id, org_id, branch_id } = academicContext;

    if (!academic_year_id || !org_id || !branch_id) {
      setNotifications([]);
      return;
    }

    Promise.all([
      fetch(`${ApiUrl.apiurl}Grievance/list/?org_id=${org_id}&branch_id=${branch_id}`).then((res) => res.json()),
      fetch(`${ApiUrl.apiurl}ACADEMIC_DOCUMENTS/${academic_year_id}/${org_id}/${branch_id}/`).then((res) => res.json()),
    ])
      .then(([grievanceRes, documentRes]) => {
        const grievanceItems = Array.isArray(grievanceRes?.data)
          ? grievanceRes.data.map((item) => ({
              dateRaw: item.submited_date || item.created_at || "",
              date: formatNotificationDate(item.submited_date || item.created_at),
              msg: `Grievance #${item.GrievanceNumber || item.Grievance_id || ""}: ${item.GrievanceType || "New grievance"}`,
            }))
          : [];

        const documentItems = Array.isArray(documentRes?.data)
          ? documentRes.data.map((item) => ({
              dateRaw: item.upload_date || "",
              date: formatNotificationDate(item.upload_date),
              msg: `Document uploaded: ${item.doc_name || "Academic Document"}`,
            }))
          : [];

        const merged = [...grievanceItems, ...documentItems]
          .sort((a, b) => new Date(b.dateRaw || 0) - new Date(a.dateRaw || 0))
          .slice(0, 8);

        setNotifications(merged);
      })
      .catch((err) => {
        console.error("Notification fetch error:", err);
        setNotifications([]);
      });
  }, [academicContext]);

  useEffect(() => {
    // Clear data when month changes
    setFeeTableData([]);
    setMonthlyCollection(0);

    const { academic_year_id, org_id, branch_id } = academicContext;
    if (!academic_year_id || !org_id || !branch_id) return;

    const start_date = formatDateKey(new Date(selectedYear, selectedMonth, 1));
    const end_date = formatDateKey(new Date(selectedYear, selectedMonth + 1, 0));

    fetch(
      `${ApiUrl.apiurl}FeesDashBoard/dashboard/?academic_year_id=${academic_year_id}&org_id=${org_id}&branch_id=${branch_id}&from_date=${start_date}&to_date=${end_date}`
    )
      .then((res) => res.json())
      .then((data) => {
        setFeeTableData(Array.isArray(data?.data) ? data.data : []);
        setMonthlyCollection(
          Number(
            data?.summary?.selected_period_total_received ||
              data?.summary?.current_month_total_received ||
              0
          )
        );
      })
      .catch((err) => console.error("Fee dashboard error:", err));
  }, [selectedMonth, selectedYear, academicContext]);

  useEffect(() => {
    const { academic_year_id, org_id, branch_id } = academicContext;

    if (!academic_year_id || !org_id || !branch_id) return;

    setSessionFeeDetails({});

    fetch(
      `${ApiUrl.apiurl}FeesDashBoard/feescalculateBasedOnAcademic/?academic_year_id=${academic_year_id}&org_id=${org_id}&branch_id=${branch_id}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data?.data) {
          const d = data.data;
          const totalCollectable = d.element_amount - d.total_discount_amount;
          const totalBalance = totalCollectable - d.total_paid_amount;

          setSessionFeeDetails({
            session: d.sesion,
            totalDues: d.element_amount,
            totalDiscount: d.total_discount_amount,
            totalCollectable,
            totalCollected: d.total_paid_amount,
            totalBalance,
          });
        }
      })
      .catch((err) => console.error("Session fee error:", err));
  }, [academicContext]);

  return (
    <div className="container-fluid">
      <Row>
        <Col>
          <div className="card p-0">
            <div className="card-body">
              {/* Summary Cards */}
              <Row className="mb-4">
                <Col md={4}>
                  <div style={summaryCardStyle("#fecaca", "#f87171")}>
                    <FaUserGraduate size={30} />
                    <div>
                      <div style={summaryTextStyle}>Total Students</div>
                      <h2 style={summaryValueStyle}>
                        {Number(totalStudents || 0).toLocaleString("en-IN")}
                      </h2>
                    </div>
                  </div>
                </Col>
                <Col md={4}>
                  <div style={summaryCardStyle("#bfdbfe", "#60a5fa")}>
                    <FaChalkboardTeacher size={30} />
                    <div>
                      <div style={summaryTextStyle}>Teachers</div>
                      <h2 style={summaryValueStyle}>
                        {Number(totalTeachers || 0).toLocaleString("en-IN")}
                      </h2>
                    </div>
                  </div>
                </Col>
                <Col md={4}>
                  <div style={summaryCardStyle("#bbf7d0", "#4ade80")}>
                    <FaMoneyBillWave size={30} />
                    <div>
                      <div style={summaryTextStyle}>Earnings</div>
                      <h2 style={summaryValueStyle}>
                        ₹
                        {sessionFeeDetails.totalCollected?.toLocaleString() ||
                          "0.00"}
                      </h2>
                    </div>
                  </div>
                </Col>
              </Row>

              {/* Progress and Notifications */}
              <Row className="mb-4">
                <Col md={6}>
                  <div style={sectionCardStyle}>
                    <div style={cardHeaderStyle}>
                      <span style={{ fontWeight: "600" }}>
                        <FaCalendarAlt
                          style={{ marginRight: "8px", color: "#6b7280" }}
                        />
                        Attendence
                      </span>
                    </div>
                    <div style={{ marginTop: "20px", textAlign: "center" }}>
                      <div
                        style={{ width: 180, height: 180, margin: "0 auto" }}
                      >
                        <CircularProgressbarWithChildren
                          value={
                            todayAttendance.total_student
                              ? (Number(todayAttendance.present_student || 0) /
                                  Number(todayAttendance.total_student || 0)) *
                                100
                              : 0
                          }
                          styles={buildStyles({
                            pathColor: "#2563eb",
                            trailColor: "#e5e7eb",
                          })}
                        >
                          <div
                            style={{
                              fontSize: 20,
                              fontWeight: "bold",
                              marginTop: -5,
                            }}
                          >
                            {Number(
                              todayAttendance.total_student
                                ? (Number(todayAttendance.present_student || 0) /
                                    Number(todayAttendance.total_student || 0)) *
                                  100
                                : 0
                            ).toFixed(1)}
                            %
                          </div>
                        </CircularProgressbarWithChildren>
                      </div>
                      <div
                        style={{
                          fontSize: "13px",
                          color: "#6b7280",
                          marginTop: "10px",
                        }}
                      >
                        Today Present: {todayAttendance.present_student || 0} of{" "}
                        {todayAttendance.total_student || 0} students
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#000000",
                          fontWeight: "700",
                          marginTop: "6px",
                        }}
                      >
                        Present: {todayAttendance.present_student || 0} | Absent: {todayAttendance.absent_student || 0} | Not marked: {todayAttendance.not_marked_student || 0}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div style={sectionCardStyle}>
                    <h6 style={{ fontWeight: "bold" }}>
                      <FaBell
                        style={{ marginRight: "8px", color: "#f59e0b" }}
                      />
                      Notifications
                    </h6>
                    <div
                      style={{
                        fontSize: "14px",
                        lineHeight: "1.7",
                        marginTop: "10px",
                      }}
                    >
                      {notifications.map((item, i) => (
                        <div key={i} style={{ display: "flex", gap: "10px" }}>
                          <span
                            style={{
                              color: "#2563eb",
                              fontWeight: "bold",
                              minWidth: "100px",
                            }}
                          >
                            {item.date}
                          </span>
                          <span>{item.msg}</span>
                        </div>
                      ))}
                      {!notifications.length && (
                        <div style={{ color: "#94a3b8" }}>No notifications available</div>
                      )}
                      
                    </div>
                  </div>
                </Col>
              </Row>

              {/* Fee Dashboard & Session Fee */}
              <Row>
                <Col md={8} className="mb-4">
                  <div style={sectionCardStyle}>
                    <div style={cardHeaderStyle}>
                      <h6 style={{ fontWeight: "bold" }}>
                        <FaCalendarAlt
                          style={{ marginRight: "8px", color: "#6b7280" }}
                        />
                        Fee Dashboard
                      </h6>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <label htmlFor="month" style={{ margin: 0 }}>
                          Month
                        </label>
                        <Select
                          id="month"
                          value={
                            monthOptions.find((opt) => opt.value === selectedMonth) ||
                            null
                          }
                          onChange={(selected) => setSelectedMonth(selected.value)}
                          options={monthOptions}
                          classNamePrefix="react-select"
                          styles={{
                            container: (provided) => ({
                              ...provided,
                              width: "200px",
                            }),
                          }}
                        />
                        <label htmlFor="year" style={{ margin: 0 }}>
                          Year
                        </label>
                        <Select
                          id="year"
                          value={
                            yearOptions.find((opt) => opt.value === selectedYear) ||
                            null
                          }
                          onChange={(selected) => setSelectedYear(selected.value)}
                          options={yearOptions}
                          classNamePrefix="react-select"
                          styles={{
                            container: (provided) => ({
                              ...provided,
                              width: "120px",
                            }),
                          }}
                        />
                      </div>
                    </div>

                    <div className="table-responsive" style={{ marginTop: "15px" }}>
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            {["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map((day) => (
                              <th key={day}>{day}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {generateFeeCalendarData().map((week, weekIndex) => (
                            <tr key={weekIndex}>
                              {week.map((day, dayIndex) => (
                                <td key={dayIndex} style={{ textAlign: "center" }}>
                                  {day && day.day}
                                  {day && day.feeReceived !== null && (
                                    <Link
                                      to="/paymentDetails"
                                      state={{ selectedDate: day.date }}
                                      style={{
                                        fontSize: "0.8em",
                                        color: "green",
                                        cursor: "pointer",
                                        display: "block",
                                      }}
                                    >
                                      Fee: {Number(day.feeReceived || 0).toLocaleString("en-IN")}
                                    </Link>
                                  )}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>

                <Col md={4} className="mb-4">
                  <div style={sectionCardStyle}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        gap: "12px",
                        marginBottom: "15px",
                      }}
                    >
                      <h6
                        style={{
                          fontWeight: "bold",
                          marginBottom: 0,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <FaFileInvoice
                          style={{ marginRight: "8px", color: "#6b7280" }}
                        />
                        Session Fee Details
                      </h6>
                    </div>
                    <ul
                      style={{
                        listStyle: "none",
                        padding: 0,
                        fontSize: "14px",
                        lineHeight: "1.8",
                      }}
                    >
                      <li>
                        <strong>Session:</strong>{" "}
                        {sessionFeeDetails.session || "N/A"}
                      </li>
                      <li>
                        <strong>Total Dues:</strong> ₹
                        {sessionFeeDetails.totalDues?.toLocaleString() ||
                          "0.00"}
                      </li>
                      <li>
                        <strong>Total Discount:</strong> ₹
                        {sessionFeeDetails.totalDiscount?.toLocaleString() ||
                          "0.00"}
                      </li>
                      <li>
                        <strong>Total Collectable:</strong> ₹
                        {sessionFeeDetails.totalCollectable?.toLocaleString() ||
                          "0.00"}
                      </li>
                      <li>
                        <strong>Total Collected:</strong> ₹
                        {sessionFeeDetails.totalCollected?.toLocaleString() ||
                          "0.00"}
                      </li>
                      <li>
                        <strong>Current Month Collection:</strong> ₹
                        {monthlyCollection.toLocaleString()}
                      </li>
                      <li>
                        <strong>Total Balance:</strong> ₹
                        {sessionFeeDetails.totalBalance?.toLocaleString() ||
                          "0.00"}
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const summaryTextStyle = { fontSize: "16px", fontWeight: 600 };
const summaryValueStyle = { marginTop: "5px", fontWeight: 700 };
const sectionCardStyle = {
  background: "#fff",
  borderRadius: "16px",
  padding: "20px",
  boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
};
const cardHeaderStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};
const summaryCardStyle = (startColor, endColor) => ({
  background: `linear-gradient(135deg, ${startColor}, ${endColor})`,
  padding: "20px",
  borderRadius: "16px",
  color: "#1f2937",
  boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
  display: "flex",
  alignItems: "center",
  gap: "15px",
});

export default AutoLayoutExample;
